import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import type { CurrencyFindInterface } from '@zaoblako/shared/modules/catalog/dtos/currency/currency-find.dto';

import * as yup from 'yup';

/** Currency rate response body - DTO signature */
export interface CurrencyRateFindInterface {
  // Tech columns
  /** Creation date and time */
  created: Date;
  /** Last update date and time */
  updated: Date;

  // Data columns
  /** Currency rate value */
  rate: number;
  /** Currency rate date */
  date: string;
  /** Currency */
  currency: CurrencyFindInterface;
}

/** Currency rate response body - DTO schema */
export const CurrencyRateFindDto = SerdeDtoClass.create<CurrencyRateFindInterface>(CatalogDtosKeysEnum.CURRENCY_RATE_FIND_DTO, {
  created: {
    label: 'Создана',
    serializer: yup.date()
  },
  updated: {
    label: 'Изменена',
    serializer: yup.date()
  },
  rate: {
    sortable: true,
    label: 'Курс',
    serializer: yup.number(),
  },
  date: {
    sortable: true,
    label: 'Дата',
    serializer: yup.string(),
  },
  currency: {
    sortable: true,
    label: 'Валюта',
    nested: CatalogDtosKeysEnum.CURRENCY_FIND_DTO,
    serializer: (_, nested) => nested,
  },
});
